<template>
  <section class="body">
    <div>
      <div class="modal-top-section modal-top-section--align-center">
        <h3 class="modal-top-section__title">Agrega usuarios</h3>
        <p class="modal-top-section__subtitle">
          Seleccione los usuarios de la campaña que deseas agregar a esta cola.
        </p>
      </div>
    </div>
    <section class="container">
      <!-- Vista seleccionar agentes -->
      <div class="section--agents">
        <div class="box">
          <div class="container__search">
            <a-input
              v-model:value="search"
              placeholder="Busca los usuarios aquí"
              class="search__agents"
            >
              <template #suffix>
                <SearchOutlined />
              </template>
            </a-input>
          </div>

          <div
            v-if="agents.length > 0 || loading"
            id="style-scroll-agente"
            class="scrollbar-agent"
            :class="agents?.length < 1 && !loading ? 'hideText' : ''"
          >
            <div class="container-items-agent">
              <UsersSekeleton class="container-items-agent" :ownerCount="1" :adminCount="4" v-if="loading" />
              <div v-else v-for="agent in listAgent" :key="agent.profile">
                <span v-if="orderedAgentsByProfile(agent.profile).length != 0">{{
                  agent.profile
                }}</span>
                <!-- <div v-if="agent.agents.length > 0" class="line-gray" /> -->
                <div
                  v-for="subAgent in orderedAgentsByProfile(agent.profile)"
                  :key="subAgent.id"
                  class="container-item__agent"
                >
                  <div class="item__agent">
                    <div class="subitem__agent">
                      <div v-if="subAgent?.picture">
                        <img class="user__icon" :src="subAgent?.picture" alt="perfil" />
                      </div>
                      <div
                        v-else
                        :class="subAgent.role.name === 'Agente' ? 'background__agent' : ''"
                        class="background__profile"
                      >
                        <img
                          v-if="subAgent.icon"
                          class="user__profile"
                          :class="subAgent.role.name === 'Agente' ? 'user__agente' : ''"
                          :src="getProfileImage(subAgent?.icon || iconDefault)"
                          alt="perfil"
                        />
                      </div>
                      <div>
                        <a-tooltip placement="top">
                          <template #title v-if="subAgent.fullname?.length > 21">
                            {{ subAgent.fullname }}
                          </template>
                          <p class="text__name">
                            {{ subAgent.fullname.toLowerCase() }}
                          </p>
                        </a-tooltip>
                      </div>
                    </div>
                    <div class="agent__event">
                      <StateCell :record="subAgent" :detailedView="false" :time="false" />
                    </div>
                    <div class="agent__event">
                      <a-badge :color="eventColor(subAgent.event_management)" />
                      <span> {{ eventText(subAgent.event_management) }}</span>
                    </div>
                    <a-checkbox
                      class="flex"
                      :checked="isAgent(subAgent)"
                      :disabled="disabledChecked(subAgent.event_management)"
                      @change="handleSelectedAgentItems($event, subAgent)"
                    >
                    </a-checkbox>
                  </div>
                  <div v-if="enableUsersPriority">
                    <a-input-number
                      :value="priorityAgent(subAgent)"
                      @change="(value) => changePriority(value, subAgent)"
                      min="1"
                      :disabled="!isAgent(subAgent)"
                      :placeholder="!isAgent(subAgent) ? '-' : ''"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text__left" v-else>
            <p class="infoUser">
              Debes agregar usuarios a la campaña asociada para visualizarlos aquí.
            </p>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { SearchOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, ref, computed, watch, createVNode, inject } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
// import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar";
import { EventData } from "@/app/shared/utils/globalVariables";
import { EventManagement, StateOptions } from "@/app/shared/utils/enums";
import StateCell from "@/app/supervision/components/tables/cells/StateCell.vue";
/*import EventsCell from "@/app/supervision/components/tables/cells/EventsCell.vue";*/
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { fetchAgentsByQueue } from "@/app/supervision/services";
import squareImage from "@/app/entities/assets/square.svg?url";
import UsersSekeleton from "@/app/shared/components/skeletons/UsersSekeleton.vue";
import agents from "@/app/shared/store/agents";
import { load } from "cheerio";

export default defineComponent({
  components: {
    SearchOutlined,
    StateCell,
    /*EventsCell,*/
    UsersSekeleton,
  },
  props: {
    isActive: {
      required: true,
      type: Boolean,
    },
    isVisible: {
      required: true,
      type: Boolean,
    },
    isEdit: {
      required: true,
      type: Boolean,
      default: false,
    },
    idPortfolio: {
      type: Number,
      default: null,
    },
    idQueue: {
      type: Number,
      default: null,
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const search = ref("");
    const select = ref("");
    const orderedAgents = ref([]);
    const deleteUser = ref(false);
    const queueState = computed(() => store.getters["getQueueState"]);
    const agentsState = computed(() => queueState.value?.users);
    const copyAgentState = [...agentsState.value];
    const selectedItems = ref(agentsState.value);
    const countToUpdate = inject("countToUpdate");
    const enableUsersPriority = inject("enableUsersPriority");
    const loading = ref(true);

    const selectedItemsIds = computed(() =>
      agentsState.value.map(el => el.id)
    );

    const priorityAgent = (agent) => {
      const index = selectedItems.value.findIndex(el => el.id == agent.id);
      if (index > -1) {
        console.log(selectedItems.value[index]?.priority, 'priority');
        console.log(index, 'index');
        return selectedItems.value[index]?.priority || 1;
      }      
      return null;
    };

    const changePriority = (event, agent) => {
      const index = selectedItems.value.findIndex(el => el.id == agent.id);
      if (index > -1) {
        selectedItems.value[index] = { ...selectedItems.value[index], priority: event };
      }
    };

    watch(
      () => [...selectedItems.value],
      () => {
        emit("onShowConfirmationModal");
      }
    );
    return {
      selectedItems,
      selectedItemsIds,
      search,
      select,
      deleteUser,
      agentsState,
      copyAgentState,
      countToUpdate,
      squareImage,
      orderedAgents,
      queueState,
      enableUsersPriority,
      changePriority,
      priorityAgent,
      loading,
    };
  },
  computed: {
    portfolio() {
      return this.$store.getters["getQueueState"].portfolios;
    },
    agents() {
      // let agents = this.$store.getters["getAgentQueue"];
      let agents = this.orderedAgents;
      if (this.search != "") {
        agents = agents.filter((agent) => {
          return agent.fullname.toLowerCase().includes(this.search.toLowerCase());
        });
      }
      return agents;
    },
    listAgent() {
      const arr = [];
      this.profiles.forEach((profile) => {
        const agents = this.agents.filter((agent) => agent.profile_name === profile.name);
        arr.push({ profile: profile.name, agents });
      });

      return arr;
    },
    selectAllCheckbox() {
      return this.selectedItems.length === this.agents.length;
    },
    profiles() {
      // let listProfiles = this.$store.getters["getProfileList"];
      // console.log({ listProfiles, grouped: this.$store.getters["image.png"] });
      // if (!listProfiles.some((profile) => profile.name === "Owner")) {
      //   listProfiles.push({ name: "Owner", total_users: 1 });
      // }
      // return listProfiles.filter((item) => item.total_users > 0);
      return this.$store.getters["getAgentQueueProfile"];
    },
  },
  async created() {
    this.loading = true;
    this.$emit("disable", false);
    await this.fetchAgentsByCampaign(this.portfolio[0]);
    this.orderedAgents = this.orderedSubAgents(this.$store.getters["getAgentQueue"]);
    this.loading = false;
    
    // this.interval = setInterval(
    //   async () => await this.fetchAgentsByCampaign(this.portfolio[0]),
    //   1000
    // );
  },
  methods: {
    orderedSubAgents(agents) {
      const selectedAgents = agents
        .filter((subAgent) => this.selectedItemsIds.includes(subAgent.id))
        .sort((a, b) => a.fullname.localeCompare(b.fullname));

      const subAgentsWithState1 = agents
        .filter((subAgent) => subAgent.state === 1 && !this.selectedItemsIds.includes(subAgent.id))
        .sort((a, b) => a.fullname.localeCompare(b.fullname));

      const subAgentsWithoutState2 = agents
        .filter((subAgent) => subAgent.state !== 1 && !this.selectedItemsIds.includes(subAgent.id))
        .sort((a, b) => a.fullname.localeCompare(b.fullname));
      return [...selectedAgents, ...subAgentsWithState1, ...subAgentsWithoutState2];
    },
    orderedAgentsByProfile(profileName) {
      return this.agents.filter((el) => el.profile_name == profileName);
    },
    getProfileImage(profile) {
      return new URL(`../../../users/assets/profiles/${profile}`, import.meta.url).href;
    },
    async fetchAgentsByCampaign(id) {
      if (id) await this.$store.dispatch("fetchAgentsQueue", id);
    },
    handleSearch() {
      const search = this.listAgent.filter((agent) =>
        agent.agents.filter((item) => {
          return item.fullname.toLowerCase().includes(this.search.toLowerCase());
        })
      );
      console.log(search);
    },
    removeSelectedItem: function (item) {
      this.$root.$emit("send", item.id);
      const el = this.selectedItemsIds.find((x) => x === item.id);
      const index = this.selectedItemsIds.indexOf(el);
      this.selectedItems.splice(index, 1);
    },
    isProfile(agent) {
      let checkProfile = false;
      agent.agents.forEach((agnt) => {
        if (this.selectedItemsIds.includes(agnt.id)) checkProfile = true;
      });
      return checkProfile;
    },
    isAgent(agent) {
      return this.selectedItemsIds.includes(agent?.id);
    },
    handleSelectedAgentItems(e, agent) {
      const checked = e.target.checked;
      if (checked) {
        this.selectedItems.push({
          id: agent.id,
          priority: agent.priority ?? 1,
        });
      } else {
        const index = this.selectedItemsIds.findIndex((item) => {
          return item == agent.id;
        });
        this.selectedItems.splice(index, 1);
        // agent.priority = null;
      }
    },
    handleSelectAllAgents(event) {
      if (event.target.checked) {
        console.log(this.listAgent, 'list agents');
        this.listAgent.forEach((item) => {
          item.agents.map((agent) => this.selectedItems.push(
            {
              id: agent.id,
              priority: agent.priority ?? 1,
            }
          ));
        });
      } else {
        this.selectedItems = [];
        this.$emit("onShowConfirmationModal");
      }
    },
    async handleOk(current) {
      let value = current;
      let removeAgents = false;
      await this.copyAgentState.forEach((agent) => {
        if (!this.selectedItemsIds.includes(agent.id)) {
          removeAgents = true;
        }
      });
      if (removeAgents) {
        await this.removeAgentsUpdate();
        // this.$emit("remove-agents");
        this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
      } else {
        this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
        value = current + 1;
        return value;
      }
    },
    removeAgentsUpdate() {
      return new Promise((res) => {
        Modal.confirm({
          title: "¿Estás seguro de quitar usuarios de esta cola?",
          content:
            "Recuerda que estos usuarios ya no recibirán tickets de esta cola, y sus tickets serán reasignados en esta cola, a otros usuarios disponibles.",
          width: 450,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => {
            res();
            // this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
            // this.$emit("updateQueue");
          },
          onCancel: () => this.$emit("keep-editing"),
          centered: true,
          okText: "Quitar",
          cancelText: "Cancelar",
        });
      });
    },
    handleReset() {
      this.selectedItems = [];
    },
    handleProfileSelected(e, agent) {
      const checked = e.target.checked;
      if (checked) {
        agent.agents.map((agnt) => {
          this.selectedItems.push(agnt.id);
        });
      } else {
        agent.agents.map((agnt) => {
          const index = this.selectedItemsIds.findIndex((item) => {
            return item == agnt.id;
          });
          this.selectedItems.splice(index, 1);
        });
      }
    },
    statusColor(id) {
      if (id === StateOptions.NotAvailable) return "#13C2C2";

      return EventData[id].color;
    },
    statusText(id) {
      if (id === StateOptions.NotAvailable) return "No disponible";

      return id === EventManagement.Online ? "Disponible" : EventData[id].name;
    },
    eventColor(id) {
      return id ? EventData?.[id]?.color : "#00000026";
    },
    eventText(id) {
      return id ? EventData?.[id]?.name : "Sin evento activo";
    },
    disabledChecked(eventId) {
      return (
        eventId === EventManagement.Talking ||
        eventId === EventManagement.Acw ||
        eventId === EventManagement.Ringing
      );
    },
  },
  watch: {
    countToUpdate(newCounterValue) {
      if (newCounterValue === 1) {
        this.fetchAgentsByCampaign(this.portfolio[0]);
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  display: flex
  box-sizing: border-box
  border-radius: 0
  justify-content: space-evenly
  .box
    background: $white
    box-sizing: border-box
    border-radius: 2px
    display: flex
    flex-direction: column
    height: 420px
  .container__information
    margin: 0 auto
    text-align: center
    margin-top: 80px
  .infoUser
    margin-top: 40px
    color: $gray-6

.container__search
  display: flex
  flex-direction: column
  margin-bottom: 10px

.item__agent
  display: flex
  justify-content: space-between
  border-radius: 10px
  align-items: center
  width: 100%
  /*margin-left: 20px */
  // margin-bottom: 10px
  padding: 5px 10px
  border: 1px solid $gray-4

.subitem__agent
  display: flex
  align-items: center

.title-agents
  margin-bottom: 0px
  font-weight: 600
  color: $gray-9

.selection-agents
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 3px
  height: 35px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0px
  justify-content: space-between
  margin-left: 20px
  margin-top: 10px
  align-items: center
input[type="checkbox"]
  width: 16px
  height: 16px
  margin-right: 8px
input:checked
  background-color: $blue-6
  &:hover
    background-color: $blue-6

.scrollbar-agent
  float: left
  overflow-y: scroll
  padding-right: 0
  width: 101%
.label-agent
  padding-left: 5px

#style-scroll-agente::-webkit-scrollbar-track
  border-radius: 10px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar
  width: 5px
  background-color:  $white
#style-scroll-agente::-webkit-scrollbar-thumb
  border-radius: 10px
  background-color: #C4C4C4

.section--agents
  /* margin-right: 12px*/
  // width: 90%

.icon--close
  color: $gray-8
  padding-left: 10px

.section__selected
  width: 49%

.checkbox__select
  border-bottom: 1px solid #E8E8E8
  margin-bottom: 10px
  padding: 8px 12px

.search__agents
  // margin-left: 7px
  width: 100%
.container-items-agent
  padding: 0 1px
  span:first-child
    font-size: 14px
    font-weight: 600
    margin-bottom: 10px

.container-item__agent
  display: flex
  align-items: center
  margin-bottom: 10px
  gap: 10px

.line-gray
  border-bottom: 1px solid #E8E8E8

.image-without-modules
  display: block
  margin: 15% 33%
.label
  font-weight: 600
  font-size: $font-normal
  line-height: 25px
  color: $gray-9
  padding-bottom: 10px
.style-container
  padding: 5px 8px
.container__image
  margin-right: 10px

.user__icon
  width: 22px
  height: 22px
  margin: 6px
  border-radius: 50%

.user__profile
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.user__agente
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 5px
  // height: 32px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 6px
  height: 32px

.text__left
  margin-top: 86px
  text-align: center

.hideText
  display: none

.flex
  display: flex
  align-items: center

.text__name
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis
  margin-right: 4px
  width: 150px
  margin-bottom: 0
  font-size: 14px
  font-weight: 600

.checkbox-content
  margin-left: 8px

.agent__event
  width: 120px
  display: flex
  align-items: center
  span
    margin-bottom: 0 !important
</style>
